class IngredientsModal extends HTMLElement {
  constructor() {
    super();
    this.modal = null;
    this.trigger = null;
    this.closeButtons = null;
  }

  connectedCallback() {
    const blockId = this.dataset.blockId;
    
    this.trigger = document.querySelector('[data-popup-trigger="' + blockId + '"]');
    this.modal = document.getElementById('ingredientsModal-' + blockId);
    
    if (this.trigger && this.modal) {
      this.closeButtons = this.modal.querySelectorAll('[data-modal-close="' + blockId + '"]');
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    this.trigger.addEventListener('click', this.openModal.bind(this));
    
    this.closeButtons.forEach((btn) => {
      btn.addEventListener('click', this.closeModal.bind(this));
    });
  }

  openModal(e) {
    e.preventDefault();
    this.modal.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.style.display = 'none';
    document.body.style.overflow = '';
  }

  disconnectedCallback() {
    if (this.trigger) {
      this.trigger.removeEventListener('click', this.openModal);
    }
    
    if (this.closeButtons) {
      this.closeButtons.forEach((btn) => {
        btn.removeEventListener('click', this.closeModal);
      });
    }
  }
}

customElements.define('ingredients-modal', IngredientsModal);
